import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconWalletLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 18v1V5v13Zm.308 2.5c-.499 0-.925-.177-1.278-.53a1.742 1.742 0 0 1-.53-1.278V5.308c0-.499.177-.925.53-1.278.353-.353.78-.53 1.278-.53h13.384c.499 0 .925.177 1.278.53.353.353.53.78.53 1.278v2.721H19V5.308a.3.3 0 0 0-.087-.221.3.3 0 0 0-.22-.087H5.307a.3.3 0 0 0-.221.087.3.3 0 0 0-.087.22v13.385a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h13.385a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22V15.97h1.5v2.721c0 .499-.177.925-.53 1.278-.353.353-.78.53-1.278.53H5.308Zm8-4c-.499 0-.925-.177-1.278-.53a1.743 1.743 0 0 1-.53-1.278V9.308c0-.499.177-.925.53-1.278.353-.353.78-.53 1.278-.53h6.384c.499 0 .925.177 1.278.53.353.353.53.78.53 1.278v5.384c0 .499-.177.925-.53 1.278-.353.353-.78.53-1.278.53h-6.384Zm6.384-1.5a.3.3 0 0 0 .221-.086.3.3 0 0 0 .087-.222V9.308a.3.3 0 0 0-.087-.222.3.3 0 0 0-.22-.086h-6.385a.3.3 0 0 0-.222.086.3.3 0 0 0-.086.222v5.384a.3.3 0 0 0 .086.222.3.3 0 0 0 .222.086h6.384ZM16 13.5c.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062 0-.417-.146-.77-.438-1.063A1.446 1.446 0 0 0 16 10.5c-.417 0-.77.146-1.063.438A1.446 1.446 0 0 0 14.5 12c0 .417.146.77.438 1.063.291.291.645.437 1.062.437Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconWalletLine;
